import { gql } from 'apollo-boost';

export const FOLDER_CACHE_SAFE_FIELDS = gql`
    fragment FolderCacheSafeFields on Folder {
        id
        title
        owner
        parent
        deletedAt
        isPinned
        pinnedRank
    }
`;
